import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export function ProductKitsSection() {
  const products = [{
    title: 'ForceX – Complete Kit',
    description: 'Out of the box, ready to work. Includes enclosed system housing for maximum efficiency and cleanliness.',
    imageLabel: '[Product Image - Complete Kit]',
    linkTo: '/products/forcex-complete',
    price: 'Best Value',
    imageUrl: 'https://cdn.magicpatterns.com/uploads/nYew1mr6dTPANQzToCfw2J/complete.png'
  }, {
    title: 'ForceX – DIY Kit',
    description: 'Build it your way. The flexible solution for contractors who want to customize your setup.',
    imageLabel: '[Product Image - DIY Kit]',
    linkTo: '/products/forcex-diy',
    price: 'Intro Pricing Available',
    imageUrl: 'https://cdn.magicpatterns.com/uploads/76x41AeJfoY4b3NAgLoMt1/DIY_KIt.png'
  }];
  return <section id="kits" className="py-20 bg-brand-light scroll-mt-20" data-id="element-520">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-521">
        <div className="text-center mb-12" data-id="element-522">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-523">
            Professional Grade Kits
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed" data-id="element-524">
            Professional-grade electric sprayer systems designed for contractors
            to apply chemicals faster, safer, and more consistently—eliminating
            manual pumping, heavy lifting, and downtime in attics, crawlspaces,
            and tight work areas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-525">
          {products.map((product, index) => <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-100 hover:shadow-xl transition-shadow flex flex-col h-full" data-id="element-526">
              <div className="h-80 bg-gray-50 flex items-center justify-center relative overflow-hidden" data-id="element-527">
                {product.imageUrl ? <img src={product.imageUrl} alt={product.title} className="w-full h-full object-contain p-6" data-id="element-528" /> : <span className="text-gray-500 font-bold text-lg" data-id="element-529">
                    {product.imageLabel}
                  </span>}
                {product.price && <div className="absolute top-4 right-4 bg-brand-yellow text-brand-dark font-bold px-3 py-1 rounded-full text-sm" data-id="element-530">
                    {product.price}
                  </div>}
              </div>
              <div className="p-6 flex flex-col flex-grow" data-id="element-531">
                <h3 className="text-2xl font-bold text-brand-dark mb-2" data-id="element-532">
                  {product.title}
                </h3>
                <p className="text-gray-600 mb-6 flex-grow" data-id="element-533">
                  {product.description}
                </p>
                <Link to={product.linkTo} className="mt-auto w-full inline-flex items-center justify-center rounded-md font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 uppercase tracking-wide bg-brand-yellow text-brand-dark hover:bg-yellow-400 focus:ring-brand-yellow h-11 px-6 text-base group" data-id="element-534">
                  View Kit
                  <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-535" />
                </Link>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}